import { FC } from 'react'
import ActivateNotificationIntegration, {
  RequiredActivateNotificationIntegration,
} from '@/components/modals/ActivateNotificationIntegration'

interface ActivateTelegramNotificationBotProps {
  open?: boolean
  setOpen?: (open: boolean) => void
  necessarily?: boolean
  integrationId?: number | null
}

const ActivateTelegramNotificationBot: FC<ActivateTelegramNotificationBotProps> = (props) => (
  <ActivateNotificationIntegration provider="telegram" {...props} />
)

export const RequiredActivateTelegramNotificationBot: FC = () => (
  <RequiredActivateNotificationIntegration provider="telegram" />
)

export default ActivateTelegramNotificationBot
